// extracted by mini-css-extract-plugin
module.exports = {"BackContainer":"Modal_BackContainer__2F4Ac","active":"Modal_active__3fzEB","Modal":"Modal_Modal__32mLz"};